import { useEffect, useState } from 'react';
import differenceInCalendarDays from 'date-fns/differenceInCalendarDays';
import isSameDay from 'date-fns/isSameDay';
import isBefore from 'date-fns/isBefore';

import {
  LAST_DISMISSED_UPGRADE_BANNER,
  HAS_SEEN_UPGRADE_BANNER
} from '../everydollar_upgrade_banner';

const DAYS_REMAINING_TO_SHOW_NOTIFICATION = [14, 10, 5, 2, 1];

export default function useRenderUpgradeNotification(subscriptionEndDate) {
  const [isNotificationShowing, setIsNotificationShowing] = useState(false);

  const daysRemaining = differenceInCalendarDays(
    subscriptionEndDate,
    Date.now()
  );

  const showNotificationAndUpdateLocalStorage = () => {
    setIsNotificationShowing(true);
    localStorage.setItem(HAS_SEEN_UPGRADE_BANNER, true);
  };

  useEffect(() => {
    const hasSeenUpgradeBanner = localStorage.getItem(HAS_SEEN_UPGRADE_BANNER);
    const lastDismissed = +localStorage.getItem(LAST_DISMISSED_UPGRADE_BANNER);
    const hasNotSeenUpgradeBannerToday = !isSameDay(Date.now(), lastDismissed);
    const hasNeverDismissedBanner = lastDismissed === 0;

    const isSubscriptionExpired = isBefore(subscriptionEndDate, Date.now());

    const shouldShowNotificationToday =
      hasNeverDismissedBanner ||
      !hasSeenUpgradeBanner ||
      (DAYS_REMAINING_TO_SHOW_NOTIFICATION.includes(daysRemaining) &&
        hasNotSeenUpgradeBannerToday);

    if (daysRemaining > 14 || isSubscriptionExpired) {
      setIsNotificationShowing(false);
    } else if (shouldShowNotificationToday) {
      showNotificationAndUpdateLocalStorage();
    } else {
      setIsNotificationShowing(false);
    }
  }, [daysRemaining, subscriptionEndDate]);

  return {
    isNotificationShowing,
    setIsNotificationShowing,
    daysRemaining
  };
}
